// based on logger.js
var logData = [];
export var Logger = {
    logClient: {
        log: function (data) {
            logData.push(data);
        }
    },
    getLog: function () {
        return logData.join('\n');
    }
};
